import PropTypes from 'prop-types';

const ChatUnreadBadge = ({ count }) => {
  if (!Number.isSafeInteger(count) || count <= 0) {
    return null;
  }

  return (
    <span className='badge badge-top-right-unread-messages'>
      {count}
    </span>
  );
};

ChatUnreadBadge.propTypes = {
  count: PropTypes.number.isRequired,
};

export default ChatUnreadBadge;
